import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import {
    usePortfolioSelection,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { ParameterType } from "../../options-table/types/ParameterType";

export function ParameterTypeSelector() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();
    
    const [chartType, setChartType] = useState<ParameterType>(ParameterType.Delta);

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        chartType: ParameterType,
    ) => {
        if (selectedPortfolio === null || selectedPortfolio.portfolioSettings === null)
            return;
        
        setChartType(chartType);
        // todo: change to selectedChartType
        selectedPortfolio.portfolioSettings.selectedOptionParameterType = chartType;
        updateSelectedPortfolio();
    };

    useEffect(() => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            setChartType(selectedPortfolio.portfolioSettings.selectedOptionParameterType);
        }
    }, [selectedPortfolio]);
    
    return (
        <ToggleButtonGroup
            exclusive
            value={chartType}
            onChange={handleChange}
        >
            <Stack direction="row" spacing={1}>
                <ToggleButton
                    value={ParameterType.Delta}
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                        marginLeft: '-20px',
                        marginTop: '19.5px',
                        height: '5px',
                        width: '5px',
                        fontWeight: 'bold'
                    }}
                >
                    D
                </ToggleButton>
                <ToggleButton
                    value={ParameterType.Gamma}
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                        marginLeft: '-20px',
                        marginTop: '5px',
                        height: '5px',
                        width: '5px',
                        fontWeight: 'bold'
                    }}
                >
                    G
                </ToggleButton>
                <ToggleButton
                    value={ParameterType.Vega}
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                        marginLeft: '-20px',
                        marginTop: '5px',
                        height: '5px',
                        width: '5px',
                        fontWeight: 'bold'
                    }}
                >
                    V
                </ToggleButton>
                <ToggleButton
                    value={ParameterType.Theta}
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                        marginLeft: '-20px',
                        marginTop: '5px',
                        height: '5px',
                        width: '5px',
                        fontWeight: 'bold'
                    }}
                >
                    T
                </ToggleButton>
                <ToggleButton
                    value={ParameterType.Rho}
                    sx={{
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                        marginLeft: '-20px',
                        marginTop: '5px',
                        height: '5px',
                        width: '5px',
                        fontWeight: 'bold'
                    }}
                >
                    R
                </ToggleButton>
            </Stack>
        </ToggleButtonGroup>
    );
}